<template>
    <div>
        <!--咨询信息添加-->
        <el-row :gutter="20">
            <el-col :span="24">
                <el-button @click="handleAddAdvisory()"
                            style="margin-bottom: 15px">
                    咨询信息添加
                </el-button>
            </el-col>
            <component @closeModal="$parentInfo.studentAdvisory.page=''"
                       :is="$parentInfo.studentAdvisory.page"
                       :student_id=$parentInfo.student_id
                       :status="$parentInfo.studentAdvisory.status"
                       :returnVisit_id="$parentInfo.studentAdvisory.returnVisit_id"
                       keep-alive></component>
        </el-row>
        <div v-if="$parentInfo.studentAdvisory.advisory" :style="{'height': $parentInfo.clientHeight-650+$parentInfo.heightChange+'px'}">
            <table class="table" v-loading="$parentInfo.studentAdvisory.loading">
                <thead>
                <tr>
                    <th>咨询时间</th>
                    <th>咨询年级</th>
                    <th>学科名</th>
                    <th>优先级</th>
                    <th>状态</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in $parentInfo.studentAdvisory.advisory" :key="item.id">
                    <td>{{item.created_at}}</td>
                    <td v-if="!item.grade">年级未填写</td>
                    <td v-else>{{item.grade.name}}</td>
                    <td v-if="!item.subject">学科未填写</td>
                    <td v-else>{{item.subject.name}}</td>
                    <td>
                        <el-rate v-model="item.impression" :disabled=true></el-rate>
                    </td>
                    <td>{{item.status}}</td>
                    <td>
                        <el-button type="primary" plain size="mini" @click="handleStudentAdvisoryDetail(item.id)">详情
                        </el-button>
                        <el-button type="primary" plain size="mini"
                                   @click="handleDeleteAdvisory(item.id)"
                                   :loading="$parentInfo.studentAdvisory.button_loading">删除
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <component @closeModal="$parentInfo.studentAdvisory.page1=''" v-bind:is="$parentInfo.studentAdvisory.page1"
                       keep-alive
                       :studentAdvisory_id="$parentInfo.studentAdvisory.page_id"></component>
        </div>
        <!--分页-->
        <div class="text-center m-t-10">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="$parentInfo.studentAdvisory.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="$parentInfo.studentAdvisory.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StudentAdvisory",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowAdvisory();
        },
        methods: {
            handleShowAdvisory() {
                //StudentAdvisory
                this.$wApi.send(this.$parentInfo.path, 'studentAdvisory', {
                    'student_id': this.$parentInfo.student_id,
                    'currentPage': this.$parentInfo.studentAdvisory.currentPage,
                    'currentPageSize': this.$parentInfo.studentAdvisory.currentPageSize,
                });
            },
            //studentAdvisory
            handleDeleteAdvisory(advisory_id) {
                this.$parentInfo.studentAdvisory.button_loading = true;
                this.$confirm('是否要删除此条咨询?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.studentAdvisory.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'deleteStudentAdvisory', {
                        'student_id': this.$parentInfo.student_id,
                        'advisory_id': advisory_id,
                    });
                }).catch(() => {
                    this.$parentInfo.studentAdvisory.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSizeChange(val) {
                this.$parentInfo.studentAdvisory.currentPageSize = val;
                this.handleShowAdvisory(this.$parentInfo.studentAdvisory.currentPage, this.$parentInfo.studentAdvisory.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.studentAdvisory.currentPage = val;
                this.handleShowAdvisory(this.$parentInfo.studentAdvisory.currentPage, this.$parentInfo.studentAdvisory.currentPageSize)
            },

            handleAddAdvisory() {
                this.$Win.openModal('Dialog_AddAdvisory', 460, 550, '添加咨询信息');
            },
            handleStudentAdvisoryDetail(id) {
                this.$Win.openModal('Dialog_ShowAdvisory', 450, 480, '咨询信息详情', {
                    'id': id
                });
            }
        }
    }
</script>

<style scoped>
</style>
